<template>
  <div
    class="row justify-content-md-center"
    style="margin-bottom: 10px; margin-top: 20px"
  >
    <div class="col-md-10 text-center">
      <div class="row" style="margin-bottom: 20px" v-if="!planoAtivo">
        <div class="col-md-12 text-center text-danger">
          <h5>
            Você não possuí um plano ativo, entre em contato para adquirir
          </h5>
        </div>
      </div>

      <div class="row" style="margin-bottom: 50px; display: none">
        <div class="col-md-12 text-center">Mensagem</div>
      </div>

      <div class="row">
        <div class="col-12 col-sm-12 col-md-12 text-center">
          <div class="text-center">
            <h1 class="tituloJogos">Live</h1>
            <h6 style=""></h6>
          </div>
          <div class="card">
            <div class="card-body">
              <ListEventosHome
                ref="listEventosHomeLive"
                :itens="itens"
                :filtroSituacao="[3]"
                :icone="false"
              />
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12 col-sm-12 col-md-12 text-center">
          <div class="text-center">
            <h1 class="tituloJogos">Next Matchs</h1>
          </div>
          <div class="card">
            <div class="card-body">
              <ListEventosHome
                ref="listEventosHome"
                :itens="itens"
                :filtroSituacao="[1]"
                :icone="false"
              />
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12 col-sm-12 col-md-12 text-center">
          <div class="text-center">
            <h1 class="tituloJogos">End Matchs</h1>
            <h6 style=""></h6>
          </div>
          <div class="card">
            <div class="card-body">
              <ListEventosHome
                ref="listEventosHomeEncerrado"
                :itens="itens"
                :filtroSituacao="[4]"
                :icone="false"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { api } from "@/services/api.js";
import util from "../includes/util.js";

import ListEventosHome from "../lists/ListEventosHome3";

export default {
  name: "Home",
  components: { ListEventosHome },
  methods: {
    meusDados() {
      this.$refs.editUsuario.carregarItem("");
    },
    async carregarItens() {
      var filtros = "";

      const response = await api.get("/evento" + filtros);
      api.valid(response.data, this.$router);

      if (Object.keys(response.data).includes("gmt")) {
        this.$refs.listEventosHomeLive.gmt = response.data.gmt;
        this.$refs.listEventosHome.gmt = response.data.gmt;
        this.$refs.listEventosHomeEncerrado.gmt = response.data.gmt;
      }

      var arrEventos = [];

      for (
        var indiceEvento = 0;
        indiceEvento < response.data.itens.length;
        indiceEvento++
      ) {
        var item = response.data.itens[indiceEvento];

        arrEventos.push(item);
      }

      this.itens = arrEventos;
    },
    formatDate(data) {
      if (data == "-") {
        return data;
      }
      return util.formatDate(data);
    },
  },
  data: function () {
    return {
      planoAtivo: true,
      isAdmin: false,
      itens: [],
    };
  },
  async mounted() {
    this.isAdmin = this.$sessao.usuario.tipoUsuario == "Administrador" || this.$sessao.usuario.tipoUsuario == "Administrador Site";

    const response = await api.get("/usuario/meus-dados");
    this.planoAtivo = response.data.item.planoAtivo || this.isAdmin;

    setInterval(this.carregarItens, 20000);

    this.carregarItens();
  },
};
</script>

<style>
.tituloJogos {
  margin-top: 15px;
}
</style>